export const WIDGET_TYPES = [
  'kpiOpenTasks',
  'kpiOverdueTasks',
  'kpiOverdueFollowups',
  'kpiActiveDemos',
  'myTasks',
  'payments',
  'notes',
  'calendar',
  'projects',
  'meetings',
  'followups',
  'endingDemos',
  'installHealth',
  'financeSummary',
] as const

export type WidgetType = (typeof WIDGET_TYPES)[number]
export type WidgetSize = 1 | 2 | 3 | 4
export const WIDGET_TONES = ['primary', 'success', 'violet', 'orange', 'danger', 'neutral'] as const
export type WidgetTone = (typeof WIDGET_TONES)[number]
export type WidgetView = 'card' | 'list'
export type WidgetDensity = 'comfortable' | 'compact'

export type WidgetConfig = {
  id: string
  type: WidgetType
  w: WidgetSize
  h: WidgetSize
  view: WidgetView
  tone: WidgetTone
  density: WidgetDensity
}

export type WidgetBodyProps = { config: WidgetConfig }

export type DashboardLayout = { widgets: WidgetConfig[]; updatedAt: string | null }

export type DashTask = { id: string; title: string; due_on: string; high_priority: boolean; done: boolean }

export type DashPayment = {
  id: string
  title: string
  party: string
  due_on: string
  amount: string
  currency: string
  direction: 'in' | 'out'
}

export type NoteColor = 'primary' | 'warning' | 'success' | 'violet'
export type DashNote = { id: string; text: string; created_at: string; color: NoteColor }

export type CalendarEventKind = 'meeting' | 'demo' | 'review' | 'call'
export type CalendarEvent = { id: string; title: string; subtitle: string; starts_at: string; kind: CalendarEventKind; online: boolean }

export type ProjectStatus = 'active' | 'planning' | 'waiting' | 'done'
export type DashProject = { id: string; name: string; status: ProjectStatus; progress: number; due_on: string; members: string[]; extra: number }

export type FinanceSummary = {
  currency: string
  income: string
  expense: string
  net: string
  cash: string
  trend: { month: string; income: number; expense: number }[]
}
